import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { Btn } from '../../../../AbstractElements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@progress/kendo-react-common';
import { faCertificate } from '@fortawesome/pro-duotone-svg-icons';
import { useSelector } from 'react-redux';
import { useAuth } from 'oidc-react';
import DisplayDataComponent from './DisplayDataComponent';

export const AuditTrailDetail = () => {
    const location = useLocation();
  const { detailData } = location?.state || {};
  console.log(detailData,'detailData1221')
  const navigate = useNavigate()
  return (
    <Container fluid={true}>
        <Row className="bg-primary rounded py-2 mb-3 sticky-top">
        <Col className="d-flex align-items-center gap-2">
          <Btn
            attrBtn={{
              color: "primary",
              onClick: () => {
                // openCloseSidebar();
                navigate(-1);
              },
              //   className: "custom-back-button",
              //   title: "Back to Menu",
              style: {
                fontSize: "18px",
                outline: "1px solid white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "4px 8px",
                paddingRight: "10px",
                // fontSize: '1rem',
                cursor: "pointer",
                marginRight: "6px",
              },
            }}
          >
            <Icon
              size="medium"
              style={{
                fontSize: "25px",
                marginRight: "5px",
                // cursor:"pointer",
              }}
              name="arrow-left"
              onClick={() => {
                navigate(-1);
              }}
            />
            Back
          </Btn>
          <FontAwesomeIcon icon={faCertificate} size="xl" />
          <Typography
            variant="h6"
            style={{ color: "white", display: "flex", alignItems: "center" }}
          >
            Audit Trail
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col sm="12" className="page-content">
            <DisplayDataComponent data={JSON.parse(detailData)}/>
            </Col>
        </Row>
    </Container>
  )
}
